import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import LoadingSpinner from '../../../../components/common/LoadingSpinner';
import General from './components/General/General';
import Estadistica from './components/Estadistica/Estadistica';
import { BillType } from './types';
import { getLocalBillByLocalId } from '../../../../crud/management_api/local_bills';
import { getallGlobalBillCategories } from '../../../../crud/configuration_api/global_bill_category';
import { getLocalBillCategoryByLocalId } from '../../../../crud/management_api/local_bill_category';
import { BsFillCaretRightFill } from 'react-icons/bs';
import { FaChartPie } from 'react-icons/fa';
import { LocalSession } from '../../../../types/LocalSession';


interface BillsProps {
  lastSession?: LocalSession | null;
}

const Bills: React.FC<BillsProps> = ({ lastSession }) => {
  const [billList, setBillList] = useState<BillType[]>([]);
  const [showListado, setShowListado] = useState(true);
  const [showStats, setShowStats] = useState(false);
  const [loading, setLoading] = useState(false);
  const [globalCategoriesList, setGlobalCategoriesList] = useState<any[]>([]);
  const [localCategoriesList, setLocalCategoriesList] = useState<any[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const user = JSON.parse(localStorage.getItem("user") ?? "{}");
        const localId = user ? Number(user.local_id) : 0;
        if (!localId) {
          console.warn("Local ID no encontrado en localStorage");
          return;
        }

        const billsResponse = await getLocalBillByLocalId(localId);
        setBillList(billsResponse.data?.reverse() || []);

        const globalResponse = await getallGlobalBillCategories();
        if (globalResponse?.data) {
          setGlobalCategoriesList(globalResponse.data);
        }

        const localCatResponse = await getLocalBillCategoryByLocalId(localId);
        if (localCatResponse?.data) {
          setLocalCategoriesList(localCatResponse.data);
        }
      } catch (error) {
        console.error("Error al obtener datos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  function handleShowListado() {
    setShowListado(true);
    setShowStats(false);
  }

  function fetchBills() {
    getLocalBillByLocalId(JSON.parse(localStorage.getItem("user") || "{}").local_id)
      .then(response => {
        setBillList(response.data?.reverse() || []);
      })
      .catch(error => {
        console.error("Error al obtener las cuentas:", error);
      });
  }

  function handleShowStats() {
    setShowStats(true);
    setShowListado(false);
  }

  // renderHeader con título principal y subtítulo dinámico
  const renderHeader = () => {
    const dynamicTitle = showListado
      ? "Cuentas"
      : "Cuentas-Estadísticas";
    const [mainTitle, subTitle] = dynamicTitle.split('-');

    return (
      <div className="mp-page-header-container">
        <h2 className="title">
          {mainTitle}
        {subTitle && (
          <h4 className="subtitle">
            {subTitle}
          </h4>
        )}
                </h2>
        <div className="buttons">
          {!showListado && (
            <Button variant='none' onClick={handleShowListado}>
              General <BsFillCaretRightFill/>
            </Button>
          )}
          {!showStats && (
            <Button variant='none' onClick={handleShowStats}>
              Estadísticas <FaChartPie/>
            </Button>
          )}
        </div>
      </div>
    );
  };

  if (loading) {
    return <LoadingSpinner text="Cargando cuentas..." transparent={true} />;
  }

  return (
    <>
      {renderHeader()}
      <div className="mp-page-content">
        {showStats && <Estadistica billsList={billList} />}
        {showListado && (
          <General
            billsList={billList}
            setBillsList={setBillList}
            globalCategoriesList={globalCategoriesList}
            localCategoriesList={localCategoriesList}
            setLocalCategoriesList={setLocalCategoriesList}
            fetchBills={fetchBills}
            localSession={lastSession}
          />
        )}
      </div>
    </>
  );
};

export default Bills;
